import { render, staticRenderFns } from "./joinUser.vue?vue&type=template&id=6381e646&"
import script from "./joinUser.vue?vue&type=script&lang=js&"
export * from "./joinUser.vue?vue&type=script&lang=js&"
import style0 from "./joinUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports